import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import { backendUrl } from '../../Services/backend-url'
import LinkButton from '../Design/LinkButton'

const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loggedIn, setLoggedIn] = useState(false)
  const [noUsername, setNoUsername] = useState('transparent ')
  const [noPassword, setNoPassword] = useState('transparent ')

  const handleSubmit = e => {
    e.preventDefault()
    const user = {
      username,
      password
    }
    username ? setNoUsername('transparent ') : setNoUsername('')
    password ? setNoPassword('transparent ') : setNoPassword('')
    if (username && password) {
      axios.post(backendUrl + 'users/login', user)
        .then(res => setLoggedIn(true))
    }
  }

  if (loggedIn) {
    return (
      <Redirect to={{
        pathname: '/logged-in',
        state: { username: username.toLowerCase() }
      }}
      />
    )
  }
  return (
    <div className='fade-in login-form-container roboto'>
      <form className='login-form mb' onSubmit={handleSubmit}>
        <input className='input-1 font100' type='text' placeholder='Username' name='username' value={username} onChange={e => setUsername(e.target.value)} />
        <div className={noUsername + 'mb font75'}>*Username Required</div>
        <input className='input-1 font100' type='password' placeholder='Password' name='password' value={password} onChange={e => setPassword(e.target.value)} />
        <div className={noPassword + 'mb font75'}>*Password Required</div>
        <input className='button-1 font125' type='submit' value='Login' />
      </form>
      <LinkButton
        sendTo='/signup'
        text='or Sign up'
      />
    </div>
  )
}

export default Login
